import { render, staticRenderFns } from "./plusMenu.vue?vue&type=template&id=80314e0e"
import script from "./plusMenu.vue?vue&type=script&lang=js"
export * from "./plusMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports